<template>
  <div class="carinfo_box">
    <ul class="carinfo">
      <li class="logo_box">
        <div class="logo" :style="brandIconBg(item.brand)"><span class="d-none">{{ item.brand }}</span></div>
      </li>
      <li class="info">
        <p class="car_number">{{ item.num }}</p>
        <p class="car_model">{{ (item.year) ? item.year + '년' : '' }} {{ item.brand }} {{ item.cname }}</p>
      </li>
      <li class="separator">/</li>
      <li class="addr">
        <p class="company">{{ item.csname }} {{ item.cssname }}</p>
        <p class="state">
          <span
            :class="(item.brk === '1') ? 'text-muted' : 'text-success' ">{{ (item.brk === '0') ? '운행중' : '주차' }}</span>
          │
          <span class="text-danger">{{ item.dtcs }}</span>
        </p>
      </li>
      <li class="separator">/</li>
      <li class="kms">
        <p class="km">
          <span class="text-muted">총 주행거리</span> {{ item.total_km | comma }}Km │
          <span class="text-muted">최근 검사일</span> {{ item.now_ins }}
        </p>
        <p class="now text-muted detail_btn" @click="lastGps(item.id)" :text="item.address">{{ item.address }}</p>
      </li>
    </ul>
    <div class="btn-group btn-group-sm custom_btn_group">
      <b-button type="button" @click="$bvModal.show('modal-ins')" class="btn custom_btn icon icon1 shadow-none">
        종합 검사일 변경
      </b-button>
      <b-button type="button" @click="$bvModal.show('modal-parts')" class="btn custom_btn icon icon2 shadow-none">
        소모품 교체 설정
      </b-button>
      <button type="button" class="btn custom_btn icon icon3 shadow-none beta">정비 신청/예약</button>
    </div>
    <b-modal id="modal-ins" ref="modal-ins" size="sm" centered hide-footer
             title-class="custom_modal_title"
             content-class="custom_modal_content"
             body-class="custom_modal_body"
             title="종합검사일 변경">
      <v-calendar @selectedDay="insSelectedDay"/>
    </b-modal>
    <b-modal id="modal-parts" ref="modal-parts" centered
             title-class="custom_modal_title"
             content-class="custom_modal_content"
             body-class="custom_modal_body"
             title="소모품 교체"
             @show="showModalParts"
             @hidden="resetModalParts"
             @ok="modalPartsHandleOk">
      <ValidationObserver ref="formParts">
        <form class="modal_parts">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="partsForm.parts">날짜를 선택해주세요.</label>
                <v-calendar @selectedDay="partsSelectedDay" class="parts_calendar_box"/>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="partsForm.parts">소모품을 선택해주세요.</label>
                <validation-provider rules="required|min_value:1" v-slot="{ errors }" tag="div" name="소모품">
                  <select id="partsForm.parts" class="form-control form-control-sm" v-model="partsForm.partsSeq">
                    <option value="0">선택</option>
                    <option v-for="(item, index) in partsOptions" :key="index" :value="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                  <span class="text-danger small" v-show="errors[0]">소모품을 선택해주세요.</span>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="partsForm.totalKm">누적 주행거리를 입력해주세요.</label>
                <validation-provider rules="required|numeric|min_value:1" v-slot="{ errors }" class="custom_km_display"
                                     tag="div" name="누적 주행거리">
                  <input type="number" id="partsForm.totalKm" class="form-control form-control-sm" autocomplete="off"
                         v-model="partsForm.totalKm"/>
                  <span class="text-danger small">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="success" @click="ok()">
          저장
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          취소
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import brandIconBg from '@/mixin/brandIconBg'
import VCalendar from '@/components/common/calendar/VCalendar'
import '@/filter/common'
import ax from '@/api/car'
import { partsOptions, setParts } from '@/api/parts'
import axLocation from '@/api/location'

export default {
  name: 'CarInfoBox',
  mixins: [brandIconBg],
  components: {
    VCalendar,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      item: {},
      partsForm: {
        carSeq: this.$route.params.seq,
        partsSeq: 0,
        totalKm: 0,
        selectDay: this.$moment().format('YYYY-MM-DD')
      },
      partsOptions: []
    }
  },
  mounted () {
    if (this.$route.params.seq) {
      ax.carInfo(this.$route.params.seq, (data) => {
        if (data) {
          this.item = data
        }
      })
    }
  },
  methods: {
    insSelectedDay (date) {
      ax.carInsChange(this.$route.params.seq, this.$moment(date).format('YYYY-MM-DD'), (message) => {
        if (message) {
          this.$notify({
            group: 'alert',
            type: 'info',
            title: '정보',
            text: message
          })
        } else {
          this.$notify({
            group: 'alert',
            type: 'warn',
            title: '경고',
            text: message
          })
        }
        this.$refs['modal-ins'].hide()
      })
    },
    partsSelectedDay (date) {
      this.partsForm.selectDay = this.$moment(date).format('YYYY-MM-DD')
    },
    showModalParts () {
      partsOptions((data) => {
        this.partsOptions = data
      })
    },
    resetModalParts () {
      this.partsForm = {
        carSeq: this.$route.params.seq,
        partsSeq: 0,
        totalKm: 0,
        selectDay: this.$moment().format('YYYY-MM-DD')
      }
    },
    modalPartsHandleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.modalPartsHandleSubmit()
    },
    modalPartsHandleSubmit () {
      this.$refs.formParts.validate().then(success => {
        if (!success) {
          return false
        }
        this.$nextTick(() => {
          setParts(this.partsForm, (message) => {
            if (message) {
              this.$notify({
                group: 'alert',
                type: 'info',
                title: '정보',
                text: message
              })
            } else {
              this.$notify({
                group: 'alert',
                type: 'warn',
                title: '경고',
                text: message
              })
            }
            this.$refs['modal-parts'].hide()
          })
        })
      })
    },
    lastGps (id) {
      axLocation.lastGps(id, response => {
        if (response) {
          this.item.address = response
        } else {
          this.item.address = '현재위치 보기 실패'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.carinfo_box {
  position: relative;
  width: calc(100% - 15px);
  height: 72px;
  background: #F8F8FB;
  border-radius: 8px;
  margin-left: 15px;

  .carinfo {
    display: inline-block;
    list-style: none;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 10px 20px;

    li {
      float: left;
      display: inline-block;
      height: 100%;
    }

    .separator {
      padding-top: 10px;
      width: 40px;
      text-align: center;
      color: #BBBBBB;
      transform: rotate(10deg);
    }

    .logo_box {
      width: 50px;
      padding-top: 5px;
      text-align: center;

      .logo {
        display: inline-block;
        height: 40px;
        width: 40px;
        background: {
          image: url('/img/company/1.png');
          repeat: no-repeat;
          position: center center;
        }
      }
    }

    .info {
      padding-top: 4px;

      .car_number {
        font-size: 14px;
        margin: 0;
      }

      .car_model {
        font-size: 12px;
        margin: 0;
      }
    }

    .addr {
      padding-top: 4px;

      .company {
        font-size: 12px;
        margin: 0;
      }

      .state {
        font-size: 12px;
        margin: 0;
      }
    }

    .kms {
      padding-top: 4px;

      .km {
        font-size: 12px;
        margin: 0;
      }

      .now {
        font-size: 12px;
        margin: 0;
      }

      .text-muted {
        color: #979799 !important;
      }
    }
  }

  .custom_btn_group {
    position: absolute;
    top: 20px;
    right: 15px;

    .custom_btn {
      color: #007DEF;
      background: rgba(0, 125, 239, 0.1);
      opacity: 0.78;
      border-radius: 100px;
      border: 0px;
      font-size: 12px;
      display: flex;
      align-items: center;
      text-align: center;
      padding: 8px 15px;
      margin-right: 15px;

      &.icon {
        &.icon1:before {
          content: '';
          width: 12px;
          height: 12px;
          margin-right: 5px;
          background-image: url('/img/icon/icon_calendar.png');
        }

        &.icon2:before {
          content: '';
          width: 12px;
          height: 12px;
          margin-right: 5px;
          background-image: url('/img/icon/icon_part.png');
        }

        &.icon3:before {
          content: '';
          width: 12px;
          height: 12px;
          margin-right: 5px;
          background-image: url('/img/icon/icon_repair.png');
        }
      }
    }
  }
}

.modal_parts {
  width: 620px;
  padding: 15px;

  label {
    font-size: 12px;
    color: #007DEF;
  }

  .custom_km_display {
    position: relative;
  }

  .custom_km_display:after {
    content: 'Km';
    position: absolute;
    right: 20px;
    top: 3px;
    color: #979799;
  }

  .parts_calendar_box {
    border: 1px solid #ced4da;
    border-radius: .2rem;
  }
}
</style>
